import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const coursesManifest: FeatureManifest = {
  id: 'courses',
  path: 'courses/*',
  navPath: '/courses',
  label: 'Khoá học',
  description: 'Quản lý khoá học Học Nhé',
  load: () => import('./entry'),
}
